export class BaseModel {
    constructor(accessKey, requestKey) {
        this.AccessKey = accessKey;
        this.RequestKey = requestKey;
    }
}

export class DatePeriod {
    constructor(obj) {
        this.StartDate = obj.StartDate;
        this.EndDate = obj.EndDate;
    }
}
